import { useEffect, useState } from 'react';
import ApiClient from '../../config/ApiClient';

export type ReportSectionState<T> = {
    data: T | null;
    loading: boolean;
    error: string | null;
};

export function useReportSection<T>(endpoint: string | null): ReportSectionState<T> {
    const [data, setData] = useState<T | null>(null);
    const [loading, setLoading] = useState(Boolean(endpoint));
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!endpoint) {
            setData(null);
            setLoading(false);
            setError(null);
            return;
        }

        let cancelled = false;
        setLoading(true);
        setError(null);

        ApiClient.get<T>(endpoint)
            .then((res) => {
                if (cancelled) return;
                if (!res.success || res.data == null) {
                    const detail = (res.errors as { detail?: string } | undefined)?.detail;
                    setError(detail || res.error || 'Failed to load report data');
                    setData(null);
                    return;
                }
                setData(res.data as T);
            })
            .catch(() => {
                if (cancelled) return;
                setError('Failed to load report data');
                setData(null);
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });

        return () => {
            cancelled = true;
        };
    }, [endpoint]);

    return { data, loading, error };
}
